import type { AssignmentProcess } from '@bliks-io/contracts';

/**
 * The process id of an assignment row, whose `process` arrives either populated
 * or as a bare id. Overloaded rather than left total: callers holding a row
 * always get a `string`, while the ones reading through an optional selection
 * get `undefined` instead of having to guard the same null themselves.
 */
export function getProcessId(process: string | AssignmentProcess): string;
export function getProcessId(
  process: string | AssignmentProcess | null | undefined
): string | undefined;
export function getProcessId(
  process: string | AssignmentProcess | null | undefined
): string | undefined {
  if (!process) return undefined;
  return typeof process === 'string' ? process : process._id;
}

export function getProcessName(process: string | AssignmentProcess | null | undefined): string {
  return !process || typeof process === 'string' ? 'Unknown' : process.name;
}

export function getDepartment(process: string | AssignmentProcess | null | undefined): string {
  if (!process || typeof process === 'string') return 'Unknown';
  const department = process.department;
  return typeof department === 'object' && department !== null && 'name' in department
    ? department.name
    : String(department);
}
